import moment from 'moment-timezone';

export class EnterpriseDashboardLocationDetails {
	public dbaName: string;
	public serviceTypeId: string;
	public serviceTypeName: string;
	public city: string;
	public stateShort: string;
	public countryName: string;
	public contractBaseRate: number;
	public productId: string;
	public productName: string;
	public utilityNameList: string;
	public address1: string;
	public address2: string;
	public zipCode: string;
	public supplierName: string;
	public contractNum: string;
	public effectiveDate: Date;
	public expirationDate: Date;

	constructor(enterpriseDashboardLocationDetails?: EnterpriseDashboardLocationDetails) {
		Object.assign(this, enterpriseDashboardLocationDetails);

		this.effectiveDate = this.effectiveDate ? new Date(moment(this.effectiveDate).format('MMM DD, YYYY 00:00:00 a')) : this.effectiveDate;
		this.expirationDate = this.expirationDate ? new Date(moment(this.expirationDate).format('MMM DD, YYYY 00:00:00 a')) : this.expirationDate;
	}
}
